<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7548_7695)">
      <path d="M13.186 24.9229H17.8367V29.8792H13.186V24.9229Z"
            fill="url(#paint0_linear_7548_7695)"
      />
      <path d="M13.186 24.9229H17.8367V29.8792H13.186V24.9229Z"
            fill="url(#paint1_linear_7548_7695)"
      />
      <path d="M13.186 24.9229H17.8367V29.8792H13.186V24.9229Z"
            fill="url(#paint2_radial_7548_7695)"
      />
      <path d="M4.04346 14.54C4.04346 11.5025 6.50589 9.04004 9.54346 9.04004H22.4564C25.494 9.04004 27.9564 11.5025 27.9564 14.54V23.9231C27.9564 24.4753 27.5087 24.9231 26.9564 24.9231H5.04346C4.49117 24.9231 4.04346 24.4753 4.04346 23.9231V14.54Z"
            fill="url(#paint3_linear_7548_7695)"
      />
      <path d="M4.04346 14.54C4.04346 11.5025 6.50589 9.04004 9.54346 9.04004H22.4564C25.494 9.04004 27.9564 11.5025 27.9564 14.54V23.9231C27.9564 24.4753 27.5087 24.9231 26.9564 24.9231H5.04346C4.49117 24.9231 4.04346 24.4753 4.04346 23.9231V14.54Z"
            fill="url(#paint4_linear_7548_7695)"
      />
      <path d="M4.04346 14.54C4.04346 11.5025 6.50589 9.04004 9.54346 9.04004H22.4564C25.494 9.04004 27.9564 11.5025 27.9564 14.54V23.9231C27.9564 24.4753 27.5087 24.9231 26.9564 24.9231H5.04346C4.49117 24.9231 4.04346 24.4753 4.04346 23.9231V14.54Z"
            fill="url(#paint5_radial_7548_7695)"
            fill-opacity="0.9"
      />
      <path d="M4.04346 14.54C4.04346 11.5025 6.50589 9.04004 9.54346 9.04004H22.4564C25.494 9.04004 27.9564 11.5025 27.9564 14.54V23.9231C27.9564 24.4753 27.5087 24.9231 26.9564 24.9231H5.04346C4.49117 24.9231 4.04346 24.4753 4.04346 23.9231V14.54Z"
            fill="url(#paint6_radial_7548_7695)"
            fill-opacity="0.33"
      />
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.6879 24.6797H5.48922C4.78082 24.6797 4.13428 24.1845 4.13428 23.4916V14.6899C4.13428 11.2986 6.88386 9.12349 10.0952 9.2902C13.4892 9.29343 16.0428 11.7937 16.0428 14.6899V23.4916C16.0428 24.1845 15.3963 24.6797 14.6879 24.6797Z"
            fill="url(#paint7_linear_7548_7695)"
      />
      <path d="M5.48922 24.4297H14.6879C15.2982 24.4297 15.7928 24.0097 15.7928 23.4916V14.6899C15.7928 11.9468 13.3654 9.54022 10.0886 9.54024C6.9962 9.37665 4.38428 11.4601 4.38428 14.6899V23.4916C4.38428 24.0097 4.87895 24.4297 5.48922 24.4297Z"
            fill="#4473C1"
      />
      <path d="M4.78027 15.2383C4.78027 12.6106 6.91042 10.4805 9.53809 10.4805C12.1658 10.4805 14.2959 12.6106 14.2959 15.2383V23.2305C14.2959 23.3685 14.184 23.4805 14.0459 23.4805H5.03027C4.8922 23.4805 4.78027 23.3685 4.78027 23.2305V15.2383Z"
            fill="url(#paint8_linear_7548_7695)"
      />
      <path d="M5.16846 15.2422C5.16846 12.6145 7.2986 10.4844 9.92627 10.4844C12.5539 10.4844 14.6841 12.6145 14.6841 15.2422V23.2344C14.6841 23.3724 14.5722 23.4844 14.4341 23.4844H5.41846C5.28039 23.4844 5.16846 23.3724 5.16846 23.2344V15.2422Z"
            fill="url(#paint9_linear_7548_7695)"
      />
      <path d="M19.5703 2.9707L24.95 2.9707C25.3918 2.9707 25.75 3.28115 25.75 3.66411L25.75 6.36732C25.75 6.75028 25.3918 7.06073 24.95 7.06073L19.5703 7.06073L19.5703 2.9707Z"
            fill="url(#paint10_linear_7548_7695)"
      />
      <path d="M19.5703 2.9707L24.95 2.9707C25.3918 2.9707 25.75 3.28115 25.75 3.66411L25.75 6.36732C25.75 6.75028 25.3918 7.06073 24.95 7.06073L19.5703 7.06073L19.5703 2.9707Z"
            fill="url(#paint11_linear_7548_7695)"
      />
      <path d="M19.5703 2.9707L24.95 2.9707C25.3918 2.9707 25.75 3.28115 25.75 3.66411L25.75 6.36732C25.75 6.75028 25.3918 7.06073 24.95 7.06073L19.5703 7.06073L19.5703 2.9707Z"
            fill="url(#paint12_linear_7548_7695)"
      />
      <path d="M20.3594 3.03735C20.3594 2.40295 19.8451 1.88867 19.2107 1.88867C18.5763 1.88867 18.062 2.40295 18.062 3.03735L18.062 12.6543L20.3594 12.6543L20.3594 3.03735Z"
            fill="url(#paint13_linear_7548_7695)"
      />
      <path d="M20.3594 3.03735C20.3594 2.40295 19.8451 1.88867 19.2107 1.88867C18.5763 1.88867 18.062 2.40295 18.062 3.03735L18.062 12.6543L20.3594 12.6543L20.3594 3.03735Z"
            fill="url(#paint14_linear_7548_7695)"
      />
      <path d="M20.3594 3.03735C20.3594 2.40295 19.8451 1.88867 19.2107 1.88867C18.5763 1.88867 18.062 2.40295 18.062 3.03735L18.062 12.6543L20.3594 12.6543L20.3594 3.03735Z"
            fill="url(#paint15_radial_7548_7695)"
      />
      <circle cx="2.40625"
              cy="2.40625"
              r="2.40625"
              transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 21.6167 15.9922)"
              fill="url(#paint16_radial_7548_7695)"
      />
      <circle cx="2.40625"
              cy="2.40625"
              r="2.40625"
              transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 21.6167 15.9922)"
              fill="url(#paint17_radial_7548_7695)"
      />
      <circle cx="2.40625"
              cy="2.40625"
              r="2.40625"
              transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 21.6167 15.9922)"
              fill="url(#paint18_radial_7548_7695)"
      />
      <path d="M7.26074 22.4843H14.4343C14.5723 22.4843 14.6843 22.3723 14.6843 22.2343V15.2421C14.6843 14.2992 14.41 14.4204 13.9368 13.681H7.26074C6.70844 13.681 6.26074 13.1287 6.26074 13.681V22.4843C6.26074 23.0366 6.70844 22.4843 7.26074 22.4843Z"
            fill="url(#paint19_linear_7548_7695)"
      />
      <path d="M7.26074 22.4843H14.4343C14.5723 22.4843 14.6843 22.3723 14.6843 22.2343V15.2421C14.6843 14.2992 14.41 14.4204 13.9368 13.681H7.26074C6.70844 13.681 6.26074 13.1287 6.26074 13.681V22.4843C6.26074 23.0366 6.70844 22.4843 7.26074 22.4843Z"
            fill="url(#paint20_linear_7548_7695)"
      />
      <path d="M7.26074 22.4843H14.4343C14.5723 22.4843 14.6843 22.3723 14.6843 22.2343V15.2421C14.6843 14.2992 14.41 14.4204 13.9368 13.681H7.26074C6.70844 13.681 6.26074 13.1287 6.26074 13.681V22.4843C6.26074 23.0366 6.70844 22.4843 7.26074 22.4843Z"
            fill="url(#paint21_linear_7548_7695)"
      />
      <path d="M7.20898 23.4844H14.4343C14.5723 23.4844 14.6843 23.3725 14.6843 23.2344V17.7775L13.9067 17.6722C13.8364 17.6282 13.747 17.6281 13.6767 17.6721L6.45459 22.1864C6.33398 22.2618 6.26074 22.394 6.26074 22.5362C6.26074 23.0599 6.6853 23.4844 7.20898 23.4844Z"
            fill="url(#paint22_linear_7548_7695)"
      />
      <path d="M7.20898 23.4844H14.4343C14.5723 23.4844 14.6843 23.3725 14.6843 23.2344V17.7775L13.9067 17.6722C13.8364 17.6282 13.747 17.6281 13.6767 17.6721L6.45459 22.1864C6.33398 22.2618 6.26074 22.394 6.26074 22.5362C6.26074 23.0599 6.6853 23.4844 7.20898 23.4844Z"
            fill="url(#paint23_linear_7548_7695)"
      />
      <path d="M7.20898 23.4844H14.4343C14.5723 23.4844 14.6843 23.3725 14.6843 23.2344V17.7775L13.9067 17.6722C13.8364 17.6282 13.747 17.6281 13.6767 17.6721L6.45459 22.1864C6.33398 22.2618 6.26074 22.394 6.26074 22.5362C6.26074 23.0599 6.6853 23.4844 7.20898 23.4844Z"
            fill="url(#paint24_linear_7548_7695)"
      />
      <path d="M7.20898 23.4844H14.4343C14.5723 23.4844 14.6843 23.3725 14.6843 23.2344V17.7775L13.9067 17.6722C13.8364 17.6282 13.747 17.6281 13.6767 17.6721L6.45459 22.1864C6.33398 22.2618 6.26074 22.394 6.26074 22.5362C6.26074 23.0599 6.6853 23.4844 7.20898 23.4844Z"
            fill="url(#paint25_linear_7548_7695)"
      />
      <path d="M13.9368 12.6812C14.41 13.4205 14.6843 14.2993 14.6843 15.2422V18.006L13.9067 18.4933C13.8364 18.5374 13.747 18.5374 13.6767 18.4935L6.45459 13.9792C6.33398 13.9038 6.26074 13.7716 6.26074 13.6294C6.26074 13.1057 6.6853 12.6812 7.20898 12.6812H13.9368Z"
            fill="url(#paint26_linear_7548_7695)"
      />
      <path d="M13.9368 12.6812C14.41 13.4205 14.6843 14.2993 14.6843 15.2422V18.006L13.9067 18.4933C13.8364 18.5374 13.747 18.5374 13.6767 18.4935L6.45459 13.9792C6.33398 13.9038 6.26074 13.7716 6.26074 13.6294C6.26074 13.1057 6.6853 12.6812 7.20898 12.6812H13.9368Z"
            fill="url(#paint27_radial_7548_7695)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7548_7695"
                      x1="16.8215"
                      y1="29.8792"
                      x2="12.835"
                      y2="29.8792"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#996A69" />
        <stop offset="0.419865"
              stop-color="#6C3C49"
        />
        <stop offset="0.77392"
              stop-color="#6C484D"
        />
        <stop offset="0.953136"
              stop-color="#776466"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7548_7695"
                      x1="18.1028"
                      y1="29.8792"
                      x2="17.3528"
                      y2="29.8792"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#855A5D" />
        <stop offset="1"
              stop-color="#855A5D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint2_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.5114 29.8792) rotate(-90) scale(4.95639 5.62268)"
      >
        <stop offset="0.771623"
              stop-color="#632F53"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#844C5A"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_7548_7695"
                      x1="20.5248"
                      y1="24.9231"
                      x2="20.5248"
                      y2="11.2425"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.742721"
              stop-color="#5097DA"
        />
        <stop offset="1"
              stop-color="#5D98DA"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7548_7695"
                      x1="16"
                      y1="24.9231"
                      x2="16"
                      y2="24.2529"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4566F9" />
        <stop offset="1"
              stop-color="#4566F9"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint5_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-2.34121 1.98102 -1.71935 -3.0639 17.9832 13.8465)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.341311"
              stop-color="#1C4AC3"
        />
        <stop offset="0.831804"
              stop-color="#264FC5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.9883 10.2092) rotate(46.9354) scale(5.77792 2.16461)"
      >
        <stop offset="0.032423"
              stop-color="#1C4AC3"
        />
        <stop offset="0.615449"
              stop-color="#264FC5"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint7_linear_7548_7695"
                      x1="17.2624"
                      y1="19.6302"
                      x2="9.2959"
                      y2="19.6302"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.221698"
              stop-color="#3B7BDE"
        />
        <stop offset="1"
              stop-color="#3C84D5"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_7548_7695"
                      x1="9.53809"
                      y1="10.4805"
                      x2="9.53809"
                      y2="23.4805"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.191106"
              stop-color="#3255BF"
        />
        <stop offset="1"
              stop-color="#3255BF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint9_linear_7548_7695"
                      x1="9.92627"
                      y1="10.4844"
                      x2="9.92627"
                      y2="22.4375"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4B1776" />
        <stop offset="1"
              stop-color="#240B46"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_7548_7695"
                      x1="22.6602"
                      y1="2.9707"
                      x2="22.6602"
                      y2="4.6582"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF8E4A" />
        <stop offset="1"
              stop-color="#F96941"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_7548_7695"
                      x1="22.6602"
                      y1="2.9707"
                      x2="22.6602"
                      y2="7.06073"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.715764"
              stop-color="#D73738"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#F13B4D"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_7548_7695"
                      x1="23.2723"
                      y1="6.06055"
                      x2="25.9686"
                      y2="6.06055"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.629067"
              stop-color="#FF824E"
              stop-opacity="0"
        />
        <stop offset="0.852184"
              stop-color="#FF8549"
        />
        <stop offset="1"
              stop-color="#FF824E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_7548_7695"
                      x1="18.062"
                      y1="6.22052"
                      x2="20.3594"
                      y2="6.22052"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9594AA" />
        <stop offset="0.0419283"
              stop-color="#958EA6"
        />
        <stop offset="0.233865"
              stop-color="#998DAB"
        />
        <stop offset="0.692708"
              stop-color="#C1BACD"
        />
        <stop offset="1"
              stop-color="#BAB4C3"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_7548_7695"
                      x1="19.2107"
                      y1="1.88867"
                      x2="19.2107"
                      y2="3.03302"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BAB9BF" />
        <stop offset="1"
              stop-color="#BAB9BF"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint15_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.5957 2.40066) rotate(-2.44064) scale(0.764343 0.293817)"
      >
        <stop stop-color="#CFCBD8" />
        <stop offset="1"
              stop-color="#CFCBD8"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint16_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(-0.289246 3.13654) rotate(-36.1438) scale(3.33791 4.02708)"
      >
        <stop offset="0.104394"
              stop-color="#9571C7"
        />
        <stop offset="1"
              stop-color="#B0B0B7"
        />
      </radialGradient>
      <radialGradient id="paint17_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(2.40625 -0.582215) rotate(90) scale(5.39471 4.66751)"
      >
        <stop offset="0.642991"
              stop-color="#948DA4"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#636697"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.3045 0.980286) rotate(-61.8214) scale(1.9853 1.49496)"
      >
        <stop offset="0.246982"
              stop-color="#D0CCDA"
        />
        <stop offset="1"
              stop-color="#B6B6BD"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint19_linear_7548_7695"
                      x1="7.34446"
                      y1="18.7092"
                      x2="13.4492"
                      y2="18.7092"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D0CBD7" />
        <stop offset="0.605836"
              stop-color="#E7DEF2"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7548_7695"
                      x1="10.4725"
                      y1="15.6562"
                      x2="9.51166"
                      y2="17.3124"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.260769"
              stop-color="#BFB8C7"
        />
        <stop offset="1"
              stop-color="#CCC4D7"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint21_linear_7548_7695"
                      x1="10.3554"
                      y1="20.3124"
                      x2="9.73041"
                      y2="19.4062"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B7B1BF" />
        <stop offset="1"
              stop-color="#E2DAEB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint22_linear_7548_7695"
                      x1="14.3867"
                      y1="24.3126"
                      x2="11.0429"
                      y2="19.5938"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CDBFDE" />
        <stop offset="1"
              stop-color="#E9E0F5"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_7548_7695"
                      x1="8.78407"
                      y1="20.5618"
                      x2="8.99172"
                      y2="20.8755"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.211732"
              stop-color="#D9D2E1"
        />
        <stop offset="1"
              stop-color="#D9D2E1"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_7548_7695"
                      x1="12.1538"
                      y1="23.4844"
                      x2="12.1064"
                      y2="21.9326"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.214437"
              stop-color="#B3A5C3"
        />
        <stop offset="1"
              stop-color="#CFC3DD"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7548_7695"
                      x1="15.329"
                      y1="23.4844"
                      x2="12.1064"
                      y2="23.1097"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.214437"
              stop-color="#625C6A"
        />
        <stop offset="1"
              stop-color="#9F98A9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7548_7695"
                      x1="10.625"
                      y1="16.7075"
                      x2="14.6843"
                      y2="10.2188"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00856962"
              stop-color="#B8B0C3"
        />
        <stop offset="0.061228"
              stop-color="#E3DFEA"
        />
        <stop offset="1"
              stop-color="#A5A0AD"
        />
      </linearGradient>
      <radialGradient id="paint27_radial_7548_7695"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.23041 16.0938) rotate(-14.9951) scale(7.24677 18.1865)"
      >
        <stop offset="0.629613"
              stop-color="#ACA5B5"
              stop-opacity="0"
        />
        <stop offset="0.912005"
              stop-color="#88858E"
        />
      </radialGradient>
      <clipPath id="clip0_7548_7695">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
